const CARD_PAYMENT_METHOD_PREFIX = "pm_card";
const FOODCARD_PAYMENT_METHOD_PREFIX = "pm_fc";

export const CARD_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${CARD_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${CARD_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${CARD_PAYMENT_METHOD_PREFIX}_name`,
    CIRCLE_LOADER: `${CARD_PAYMENT_METHOD_PREFIX}_circle_loader`,
    BALANCE: `${CARD_PAYMENT_METHOD_PREFIX}_bal`,
    TICK: `${CARD_PAYMENT_METHOD_PREFIX}_tick`,
    DISABLE_MESSAGE: `${CARD_PAYMENT_METHOD_PREFIX}_disable_msg`,
    ALERT_MESSAGE: `${CARD_PAYMENT_METHOD_PREFIX}_alert_msg`,
    CVV: `${CARD_PAYMENT_METHOD_PREFIX}_cvv`,
    CVV_MESSAGE: `${CARD_PAYMENT_METHOD_PREFIX}_cvv_message`,
    PAY_BUTTON: `${CARD_PAYMENT_METHOD_PREFIX}_pay_btn`,
};

export const CARD_PAYMENT_METHODE_CHECKBOX_WRAPPER = {
    CONTAINER: `${CARD_PAYMENT_METHOD_PREFIX}_cbw_container`,
    CHECKBOX: `${CARD_PAYMENT_METHOD_PREFIX}_cbw_checkbox`,
    LINK: `${CARD_PAYMENT_METHOD_PREFIX}_cbw_link`,
};

export const FOOD_CARD_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${FOODCARD_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${FOODCARD_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${FOODCARD_PAYMENT_METHOD_PREFIX}_name`,
    CIRCLE_LOADER: `${FOODCARD_PAYMENT_METHOD_PREFIX}_circle_loader`,
    BALANCE: `${FOODCARD_PAYMENT_METHOD_PREFIX}_bal`,
    TICK: `${FOODCARD_PAYMENT_METHOD_PREFIX}_tick`,
    DISABLE_MESSAGE: `${FOODCARD_PAYMENT_METHOD_PREFIX}_disable_msg`,
    ALERT_MESSAGE: `${FOODCARD_PAYMENT_METHOD_PREFIX}_alert_msg`,
    CVV: `${FOODCARD_PAYMENT_METHOD_PREFIX}_cvv`,
    PAY_BUTTON: `${FOODCARD_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
